import React from "react";
import { Box } from "@chakra-ui/react";

export const PaintSplatBackground: React.FC = () => {
  return (
    <Box
      position="absolute"
      top="0"
      left="0"
      width="100%"
      height="100%"
      overflow="hidden"
      zIndex="0"
      pointerEvents="none"
    >
      {/* Soft cream/off-white base */}
      <Box
        position="absolute"
        width="100%"
        height="100%"
        background="linear-gradient(135deg, #fef9f3 0%, #fdf5ed 50%, #fef6f0 100%)"
      />

      {/* Paint splats SVG */}
      <svg
        className="paint-splats-svg"
        viewBox="0 0 1440 900"
        preserveAspectRatio="xMidYMid slice"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
      >
        <defs>
          {/* Pastel color definitions */}
          <linearGradient id="pastelPink" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#ffb6c1" stopOpacity="0.85" />
            <stop offset="100%" stopColor="#ffc0cb" stopOpacity="0.7" />
          </linearGradient>
          <linearGradient id="pastelBlue" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#a8d8ea" stopOpacity="0.85" />
            <stop offset="100%" stopColor="#b8e0f0" stopOpacity="0.7" />
          </linearGradient>
          <linearGradient id="pastelYellow" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#fff3b0" stopOpacity="0.85" />
            <stop offset="100%" stopColor="#fff8c9" stopOpacity="0.7" />
          </linearGradient>
          <linearGradient id="pastelGreen" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#b5ead7" stopOpacity="0.85" />
            <stop offset="100%" stopColor="#c5f0e0" stopOpacity="0.7" />
          </linearGradient>
          <linearGradient id="pastelPurple" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#c9b1ff" stopOpacity="0.85" />
            <stop offset="100%" stopColor="#d4c1ff" stopOpacity="0.7" />
          </linearGradient>
          <linearGradient id="pastelOrange" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#ffcba4" stopOpacity="0.85" />
            <stop offset="100%" stopColor="#ffd8b8" stopOpacity="0.7" />
          </linearGradient>
          <linearGradient id="pastelMint" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#98ddca" stopOpacity="0.85" />
            <stop offset="100%" stopColor="#a8e6d5" stopOpacity="0.7" />
          </linearGradient>
          <linearGradient id="pastelCoral" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#ffb5a7" stopOpacity="0.85" />
            <stop offset="100%" stopColor="#ffc5b8" stopOpacity="0.7" />
          </linearGradient>
        </defs>

        {/* Large background splats */}
        <g className="splats-back">
          {/* Pink splat - top left */}
          <path
            className="splat-1"
            d="M80,120 Q60,80 100,60 Q140,40 180,80 Q220,60 240,100 Q280,90 260,140 Q290,180 250,200 Q270,240 220,250 Q200,290 160,260 Q120,280 100,240 Q60,260 70,210 Q30,190 50,150 Q20,120 80,120 Z"
            fill="url(#pastelPink)"
          />
          {/* Blue splat - top right */}
          <path
            className="splat-2"
            d="M1200,80 Q1160,40 1220,30 Q1280,20 1320,60 Q1380,40 1400,100 Q1440,120 1400,160 Q1430,200 1380,220 Q1400,270 1340,260 Q1320,300 1270,280 Q1220,310 1200,260 Q1150,280 1160,220 Q1110,200 1140,150 Q1100,120 1200,80 Z"
            fill="url(#pastelBlue)"
          />
          {/* Yellow splat - bottom left */}
          <path
            className="splat-3"
            d="M100,700 Q60,660 120,640 Q160,600 210,650 Q260,620 280,680 Q340,670 320,730 Q370,780 310,810 Q330,860 270,860 Q240,900 190,870 Q140,900 130,840 Q70,860 90,800 Q40,770 80,730 Q30,700 100,700 Z"
            fill="url(#pastelYellow)"
          />
          {/* Green splat - bottom right */}
          <path
            className="splat-4"
            d="M1250,750 Q1210,700 1270,680 Q1320,650 1370,700 Q1420,680 1430,740 Q1470,780 1420,820 Q1450,870 1390,880 Q1380,930 1320,900 Q1270,940 1240,890 Q1180,910 1200,850 Q1140,830 1180,780 Q1130,750 1250,750 Z"
            fill="url(#pastelGreen)"
          />
          {/* Purple splat - center top */}
          <path
            className="splat-5"
            d="M680,60 Q640,20 700,10 Q760,-10 810,40 Q870,20 890,80 Q950,90 920,150 Q970,200 910,220 Q940,280 870,280 Q850,340 790,300 Q730,340 710,280 Q650,300 660,240 Q590,220 630,160 Q580,120 680,60 Z"
            fill="url(#pastelPurple)"
          />
        </g>

        {/* Medium splats */}
        <g className="splats-mid">
          {/* Orange splat */}
          <path
            className="splat-6"
            d="M400,350 Q370,310 420,300 Q470,280 500,320 Q550,300 560,360 Q610,380 570,420 Q600,470 540,480 Q550,530 490,510 Q450,550 430,500 Q380,520 390,460 Q340,440 370,400 Q320,370 400,350 Z"
            fill="url(#pastelOrange)"
          />
          {/* Mint splat */}
          <path
            className="splat-7"
            d="M950,400 Q910,360 970,340 Q1030,320 1070,370 Q1130,350 1140,410 Q1200,440 1150,490 Q1190,540 1120,560 Q1130,620 1060,600 Q1020,650 990,590 Q930,620 940,560 Q870,540 910,480 Q860,450 950,400 Z"
            fill="url(#pastelMint)"
          />
          {/* Coral splat - bottom center */}
          <path
            className="splat-8"
            d="M650,650 Q610,610 670,590 Q730,560 780,620 Q840,600 860,660 Q920,690 870,740 Q910,800 840,820 Q850,880 780,860 Q730,910 700,850 Q640,880 650,810 Q580,790 620,740 Q560,700 650,650 Z"
            fill="url(#pastelCoral)"
          />
        </g>

        {/* Small accent splats */}
        <g className="splats-small">
          <ellipse cx="300" cy="200" rx="40" ry="35" fill="url(#pastelBlue)" className="mini-splat-1" />
          <ellipse cx="1100" cy="180" rx="35" ry="30" fill="url(#pastelPink)" className="mini-splat-2" />
          <ellipse cx="200" cy="500" rx="30" ry="25" fill="url(#pastelPurple)" className="mini-splat-3" />
          <ellipse cx="1300" cy="450" rx="35" ry="30" fill="url(#pastelYellow)" className="mini-splat-4" />
          <ellipse cx="550" cy="150" rx="25" ry="20" fill="url(#pastelGreen)" className="mini-splat-5" />
          <ellipse cx="850" cy="250" rx="30" ry="25" fill="url(#pastelOrange)" className="mini-splat-6" />
          <ellipse cx="450" cy="750" rx="35" ry="28" fill="url(#pastelMint)" className="mini-splat-7" />
          <ellipse cx="1050" cy="700" rx="30" ry="25" fill="url(#pastelCoral)" className="mini-splat-8" />
        </g>

        {/* Paint drips */}
        <g className="paint-drips">
          <path
            className="drip-1"
            d="M180,200 Q185,230 180,270 Q175,290 180,310 Q190,340 180,360"
            stroke="#ffb6c1"
            strokeWidth="8"
            strokeLinecap="round"
            fill="none"
            opacity="0.6"
          />
          <path
            className="drip-2"
            d="M1320,160 Q1325,200 1320,250 Q1315,280 1320,320"
            stroke="#a8d8ea"
            strokeWidth="6"
            strokeLinecap="round"
            fill="none"
            opacity="0.6"
          />
          <path
            className="drip-3"
            d="M720,280 Q725,320 720,370 Q715,400 720,440 Q730,480 720,510"
            stroke="#c9b1ff"
            strokeWidth="7"
            strokeLinecap="round"
            fill="none"
            opacity="0.6"
          />
        </g>

        {/* Tiny paint dots scattered around */}
        <g className="paint-dots">
          <circle cx="150" cy="300" r="6" fill="#ffb6c1" opacity="0.7" />
          <circle cx="280" cy="150" r="5" fill="#a8d8ea" opacity="0.7" />
          <circle cx="420" cy="220" r="4" fill="#fff3b0" opacity="0.7" />
          <circle cx="600" cy="100" r="5" fill="#b5ead7" opacity="0.7" />
          <circle cx="780" cy="180" r="6" fill="#c9b1ff" opacity="0.7" />
          <circle cx="920" cy="130" r="4" fill="#ffcba4" opacity="0.7" />
          <circle cx="1050" cy="250" r="5" fill="#98ddca" opacity="0.7" />
          <circle cx="1200" cy="300" r="6" fill="#ffb5a7" opacity="0.7" />
          <circle cx="350" cy="400" r="4" fill="#ffc0cb" opacity="0.7" />
          <circle cx="500" cy="480" r="5" fill="#b8e0f0" opacity="0.7" />
          <circle cx="750" cy="520" r="6" fill="#fff8c9" opacity="0.7" />
          <circle cx="1150" cy="550" r="4" fill="#c5f0e0" opacity="0.7" />
          <circle cx="250" cy="650" r="5" fill="#d4c1ff" opacity="0.7" />
          <circle cx="550" cy="800" r="4" fill="#ffd8b8" opacity="0.7" />
          <circle cx="900" cy="750" r="6" fill="#a8e6d5" opacity="0.7" />
          <circle cx="1100" cy="820" r="5" fill="#ffc5b8" opacity="0.7" />
        </g>
      </svg>

      {/* Floating paint particles */}
      <Box className="paint-particles" position="absolute" width="100%" height="100%" top="0" left="0">
        {[...Array(12)].map((_, i) => (
          <Box
            key={i}
            className={`paint-particle paint-particle-${i + 1}`}
            position="absolute"
            width={6 + (i % 4) * 2 + "px"}
            height={6 + (i % 4) * 2 + "px"}
            borderRadius="50%"
            backgroundColor={
              i % 6 === 0 ? "#ffb6c1" :
              i % 6 === 1 ? "#a8d8ea" :
              i % 6 === 2 ? "#fff3b0" :
              i % 6 === 3 ? "#b5ead7" :
              i % 6 === 4 ? "#c9b1ff" :
              "#ffcba4"
            }
            opacity="0"
          />
        ))}
      </Box>
    </Box>
  );
};

export default PaintSplatBackground;
